import React from 'react'
import NotFound from '../components/NotFound'

export default function NothingFoundPage() {
    return(
        <div className="centralized-container">
            <div className="content-of-centralized-container">
                <NotFound />
            </div>
        </div>
    )
}